export { MENTION_REGEX_G } from 'firebaseFunctions/constants/regexConstants'
// eslint-disable-next-line
export const MENTION_REGEX = /\[@([^\]]*)]\(@([^\)]*)\)/

export const MENTION_MARKER = '_'

export const TOUCH_REGEX = /iphone|ipad|ipod|android|iemobile|blackberry/i
export const ANDROID_REGEX = /android/i
